/**
 * Fontawesome Javascript SVG api
 *
 * https://fontawesome.com/how-to-use/with-the-api/setup/getting-started
 */

import { library, dom } from '@fortawesome/fontawesome-svg-core';

// Import specific icons required. This format applies tree-shaking
import { faUserAstronaut } from '@fortawesome/free-solid-svg-icons/faUserAstronaut';
import { faRocket } from '@fortawesome/free-solid-svg-icons/faRocket';
import { faSpaceShuttle } from '@fortawesome/free-solid-svg-icons/faSpaceShuttle';
import { faUser } from '@fortawesome/free-solid-svg-icons/faUser';
import { faInfo } from '@fortawesome/free-solid-svg-icons/faInfo';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons/faChevronDown';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons/faChevronUp';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons/faChevronLeft';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons/faChevronRight';
import { faPhone } from '@fortawesome/free-solid-svg-icons/faPhone';
import { faPhoneAlt } from '@fortawesome/free-solid-svg-icons/faPhoneAlt';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons/faCheckCircle';
import { faFile } from '@fortawesome/free-solid-svg-icons/faFile';
import { faMedkit } from '@fortawesome/free-solid-svg-icons/faMedkit';

// Add specific icons required
library.add(
  faUserAstronaut,
  faRocket,
  faSpaceShuttle,
  faUser,
  faInfo,
  faPhone,
  faPhoneAlt,
  faChevronDown,
  faChevronUp,
  faChevronRight,
  faChevronLeft,
  faCheckCircle,
  faFile,
  faMedkit
);

// Replace any existing <i> tags with <svg> and set up a MutationObserver to
// continue doing this as the DOM changes.
export default () => dom.watch();
